// assume orga is probably gandi when empty string (T71241)
export const PUBLIC_ORGNAME = 'Gandi';